import ValidationStore from 'lib/stores/validationStore';

const useFormValid = page => {
  const validations = ValidationStore.useState(state => state[page], [page]);

  if (!validations) return [];

  const formValid = Object.keys(validations).filter(key => validations[key].valid === false).length === 0;

  return [formValid];
};

export default useFormValid;
